<template>
	<aside class="iv2-extra-sns theme-b__extra-sns-bg text-center d-none d-xl-block">
		<div
			v-if="
                sns.facebook &&
                    sns.instagram &&
                    sns.twitter &&
                    sns.line &&
                    rss.outbound
            "
			class="iv2-extra-sns-nav pt-2"
		>
			<div class="iv2-extra-sns-nav-block" :class="{ active: scrollY > 300, fixed: activeScroll }">
				<ul class="iv2-extra-sns-nav-list list-unstyled">
					<li v-if="sns.facebook" class="iv2-extra-sns-nav-item">
						<a
							v-if="sns.facebook.status == 1"
							:href="sns.facebook.url"
							class="iv2-extra-sns-nav-link theme-b__extra-sns-link"
							target="_blank"
							rel="noopener"
						>
							<i class="iv2-extra-sns-nav-item-icon fab fa-facebook-f"></i>
						</a>
					</li>
					<li v-if="sns.instagram" class="iv2-extra-sns-nav-item">
						<a
							v-if="sns.instagram.status == 1"
							:href="sns.instagram.url"
							class="iv2-extra-sns-nav-link theme-b__extra-sns-link"
							target="_blank"
							rel="noopener"
						>
							<i class="iv2-extra-sns-nav-item-icon fab fa-instagram"></i>
						</a>
					</li>
					<li v-if="sns.twitter" class="iv2-extra-sns-nav-item">
						<a
							v-if="sns.twitter.status == 1"
							:href="sns.twitter.url"
							class="iv2-extra-sns-nav-link theme-b__extra-sns-link"
							target="_blank"
							rel="noopener"
						>
							<i class="iv2-extra-sns-nav-item-icon fab fa-twitter"></i>
						</a>
					</li>
					<li v-if="sns.line" class="iv2-extra-sns-nav-item">
						<a
							v-if="sns.line.status == 1"
							:href="sns.line.url"
							class="iv2-extra-sns-nav-link theme-b__extra-sns-link"
							target="_blank"
							rel="noopener"
						>
							<i class="iv2-extra-sns-nav-item-icon fab fa-line"></i>
						</a>
					</li>
					<li v-if="rss.outbound" class="iv2-extra-sns-nav-item">
						<a
							v-if="rss.outbound.status == 1"
							:href="rss.outbound.href"
							class="iv2-extra-sns-nav-link theme-b__extra-sns-link"
							target="_blank"
							rel="noopener"
						>
							<i class="iv2-extra-sns-nav-item-icon fas fa-rss"></i>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</aside>
</template>

<script>
export default {
	data() {
		return {
			sns: [],
			rss: [],

			activeScroll: false,
			scrollY: 0,
		};
	},

	created() {
		this.axios.get("/json/settings.json").then((response) => {
			this.sns = response.data.settings.sns;
		});
		this.axios.get("/json/rss.json").then((response) => {
			this.rss = response.data.rss;
		});

		if (this.$route.path !== "/") {
			this.activeScroll = true;
		}
	},

	mounted() {
		window.addEventListener("scroll", this.handleScroll);
	},

	methods: {
		handleScroll() {
			this.scrollY = window.scrollY;
		},
	},

	watch: {
		$route: function (to, from) {
			if (to.path !== from.path && this.$route.path !== "/") {
				this.activeScroll = true;
			} else {
				this.activeScroll = false;
			}
		},
	},
};
</script>

<style lang="scss">
.iv2-extra-sns {
	.iv2-extra-sns-nav {
		height: 100%;
		position: relative;

		.iv2-extra-sns-nav-block {
			position: absolute;
			bottom: 110px;
			transition: 1s;

			&.fixed {
				bottom: 0px;
			}

			&.active {
				bottom: 110px;
			}

			.iv2-extra-sns-nav-list {
				margin-top: 60px;
				width: 80px;

				.iv2-extra-sns-nav-link {
					margin: 0 10px;
				}

				.iv2-extra-sns-nav-item {
					.iv2-extra-sns-nav-item-icon {
						font-size: 1rem;
					}
				}
			}
		}
	}
}

/* PC */
@media (min-width: 1200px) {
}

/* TABLET or SP */
@media (max-width: 1199px) {
}

/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
}

/* SP Only */
@media (max-width: 767px) {
}
</style>
